import { useCallback, useState } from "react"

export const useDelayedChoice = (delayedChoiceDuration: number) => {
    const [isDelayed, setIsDelayed] = useState<boolean>(delayedChoiceDuration > 0)
    const startDelay = useCallback(() => {
        if(delayedChoiceDuration <= 0) return;
        setIsDelayed(true);
        setTimeout(() => {
            setIsDelayed(false)
        }, delayedChoiceDuration)
    }, [delayedChoiceDuration])
    return { isDelayed, startDelay }
}